import { render } from "./FaqsComponent.vue?vue&type=template&id=4dd8d79e"
import script from "./FaqsComponent.vue?vue&type=script&lang=js"
export * from "./FaqsComponent.vue?vue&type=script&lang=js"

import "./FaqsComponent.vue?vue&type=style&index=0&id=4dd8d79e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__